import React, { ReactNode } from "react";

type PhantomProps = {
    children?: ReactNode;
    [x: string]: any;
};

export const Phantom = ({ children, ...props }: PhantomProps) => {
    const MapChildren = (children: React.ReactNode) =>
        React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return child;
            const x: any = child;
            const newProps = { ...props, ...child.props };
            return React.cloneElement(child, newProps);
            /*
            return !child.props?.children
                ? child
                : React.cloneElement(child, { ...child.props, children: MapChildren(child.props.children) });
            */
        });

    return !props ? children : MapChildren(children);
};
